import React from 'react';
import Telcontent from '../components/Telcontent';
import Footer from '../components/footer';


const Telcopage = () => {
  return (
    <div className="Telco">
          
          <Telcontent />
          <Footer />
    </div>
  );
}

export default Telcopage;